<template>
  <svg
    class="brand-mark"
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    role="img"
    aria-label="Municipal Collectionz"
  >
    <!-- Seal: navy disc, cream ring, City Hall pediment and columns, green "paid" check -->
    <circle cx="20" cy="20" r="19" :fill="ink" />
    <circle cx="20" cy="20" r="15.5" fill="none" :stroke="paper" stroke-opacity="0.35" stroke-width="1" />
    <path d="M11 16.2 L20 10.5 L29 16.2 Z" :fill="paper" />
    <rect x="12.6" y="17.6" width="2.6" height="8.4" rx="0.4" :fill="paper" />
    <rect x="18.7" y="17.6" width="2.6" height="8.4" rx="0.4" :fill="paper" />
    <rect x="24.8" y="17.6" width="2.6" height="8.4" rx="0.4" :fill="paper" />
    <rect x="11" y="27" width="18" height="2.4" rx="0.4" :fill="paper" />
    <circle cx="31" cy="31" r="7" fill="#1E6B52" :stroke="ring" stroke-width="2" />
    <path d="M27.8 31.1 L30.1 33.3 L34.2 28.9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: "BrandMark",
  props: {
    size: { type: [Number, String], default: 40 },
    // "light" for cream backgrounds, "dark" for navy backgrounds
    on: { type: String, default: "light" },
  },
  computed: {
    ink() {
      return this.on === "dark" ? "#F3EDE0" : "#0E2236";
    },
    paper() {
      return this.on === "dark" ? "#0E2236" : "#F6F1E6";
    },
    ring() {
      return this.on === "dark" ? "#0B1D2E" : "#F6F1E6";
    },
  },
};
</script>

<style scoped>
.brand-mark {
  flex: 0 0 auto;
  display: block;
  overflow: visible;
}
</style>